import FormBtn from "app/Components/CommanComponents/FormBtn";
import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import InputError from "app/Components/_form/InputError/InputError";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Col, FormGroup, Row, Button } from "react-bootstrap";
// import { employeeEmploymentStatusList, contractorPersonEmploymentStatusList } from "./Constant";
import Label from "app/Components/_form/Label/Label";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";

import { useParams } from "react-router-dom";
import toastr from "toastr";
import {
  ContractorPersonActions,
  contractorPersonEmploymentStatusList,
  contractorPersonFormLabel,
} from "./Constant";
import {
  getContractorPersonById,
  updateContractorPersonEmploymentStatus,
} from "app/_services/UserManagement/ContractorPersonService";
import {
  WidgetBox,
  initialMedicalValidation,
  initialTrainingValidation,
} from "../Employee/Constant";
import { DDMMYYYYFormat, isAfter } from "app/_helpers/dateHelper";
import InitialMedicalForm from "../Employee/Component/InitialMedicalForm";
import InitialTrainingForm from "../Employee/Component/InitialTrainingForm";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import InitialLocationForm from "../Employee/Component/InitialLocationForm";
import { getActiveContractor } from "app/_services/Contractor/ContractorService";
import ConfirmationModal from "../Employee/Component/ConfimationModal";
import { confirmAlert } from "react-confirm-alert";
import StatusHistoryList from "../Employee/Component/StatusHistoryList";
import { useHistory } from "react-router-dom";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function ContractorPersonEmploymentForm() {
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const [contractorList, setContractorList] = useState([]);
  const { id } = useParams();
  const [isDisable, setIsDisable] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [staticForm, setStaticForm] = useState({});
  const [initialForm, setInitialForm] = useState({});
  const [confirmation, setConfirmation] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const { goBack } = useHistory();

  const getAllContractorList = async () => {
    let response = await getActiveContractor();
    if (!response?.data || !response?.status) return;
    setContractorList(response.data);
  };
  useEffect(() => {
    getAllContractorList();
  }, []);

  /***************** Api Call ********************/
  const getFormData = useCallback(async () => {
    getContractorPersonById(id).then((response) => {
      if (!response?.data) return;
      const row = response.data;
      setForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
        // isPmeDate: row?.isPmeDate || false,
        // isRefresherDate: row?.isRefresherDate || false,
        retireResignDate: row?.dateOfSeparation,
        isPmeDate: row?.isPmeDate ? true : false,
        pmeDate: row?.lastPMEDate,
        isIMEDate: row?.isIMEDate ? true : false,
        imeDate: row?.lastIMEDate,
      });
      setStaticForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
        // isPmeDate: row?.isPmeDate || false,
        // isRefresherDate: row?.isRefresherDate || false,
        isPmeDate: row?.isPmeDate ? true : false,
        pmeDate: row?.lastPMEDate,
        isIMEDate: row?.isIMEDate ? true : false,
        imeDate: row?.lastIMEDate,
      });
    });
  }, [id]);

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};
    if (
      name === "employmentStatus" &&
      value !== form?.employmentStatus &&
      value === "active"
    ) {
      extraToChange.dateOfSeparation = "";
      extraToChange.remark = "";
    }

    if (
      name === "employmentStatus" &&
      value !== form?.employmentStatus &&
      value !== "active"
    ) {
      extraToChange.dateOfReJoining = "";
    }

    if (name === "currentWorkLocation" && value !== form?.currentWorkLocation) {
      if (
        siteList
          .filter((d) => d.siteType === 3)
          .map((d) => d.id)
          .includes(+value)
      ) {
        if (!form?.lastIMEDate && !form?.lastPMEDate) {
          extraToChange.mineTag = "yes";
          extraToChange.trainingEligibility = "";
          extraToChange.trainingDesignation = "";
          // extraToChange.isPmeDate = false;
          // extraToChange.pmeDate = "";
          extraToChange.specialMedicalExamEligibility = "";
          extraToChange.specialMedicalExamCategory = "";
        } else extraToChange.mineTag = "yes";
      } else {
        extraToChange.mineTag = "no";
        // extraToChange.startDateAtMines = "";
      }
    }

    if (name === "siteType" && value !== form?.siteType) {
      extraToChange.currentWorkLocation = "";
      extraToChange.startDateAtMines = "";
      extraToChange.endDateAtMines = "";
      extraToChange.mineTag = "no";
    }

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  let query = "checkPreviousRecord=true";

  const onSubmit = useCallback(
    async (e, checkExisting = true) => {
      if (e) e.preventDefault();
      let errorObj = {};

      if (["inActive"].includes(form?.employmentStatus)) {
        if (!form?.dateOfSeparation)
          errorObj["dateOfSeparation"] =
            contractorPersonFormLabel["dateOfSeparation"] + " is Required.";

        if (!form?.remark)
          errorObj["remark"] = contractorPersonFormLabel["remark"] + " is Required.";
      }

      if (form?.employmentStatus === "active") {
        if (!form?.dateOfReJoining)
          errorObj["dateOfReJoining"] =
            contractorPersonFormLabel["dateOfJoining"] + " is Required.";

        if (form.siteType) {
          if (!form.currentWorkLocation) {
            errorObj["currentWorkLocation"] =
              contractorPersonFormLabel["currentWorkLocation"] + " is Required.";
          }

          // if (form.currentWorkLocation) {
          if (!form.startDateAtMines)
            errorObj["startDateAtMines"] =
              contractorPersonFormLabel["startDateAtMines"] + " is Required.";
          // }

          if (
            form?.dateOfReJoining &&
            form?.startDateAtMines &&
            isAfter(form?.dateOfReJoining, form?.startDateAtMines)
          ) {
            errorObj["startDateAtMines"] =
              contractorPersonFormLabel["startDateAtMines"] +
              " Can't Before " +
              contractorPersonFormLabel["dateOfJoining"];
          }
        } else {
          errorObj["siteType"] = contractorPersonFormLabel["siteType"] + " is Required.";
        }

        if (!form.contractorId) {
          errorObj["contractorId"] =
            contractorPersonFormLabel["contractorId"] + " is Required.";
        }

        if (showTraining) {
          errorObj = initialTrainingValidation(errorObj, form);
        }

        if (form?.siteType === 3) {
          errorObj = initialMedicalValidation(errorObj, form);
        }
      }

      setError((prev) => ({
        ...errorObj,
      }));

      if (Object.values(errorObj).filter((d) => d !== "").length) return;
      setLoading(true);

      let joiningDate = form.dateOfReJoining || form.dateOfJoining;
      let formObj = {};
      if (form.employmentStatus !== "active") {
        let extraObj = {
          remark: form?.remark,
          dateOfSeparation: form?.dateOfSeparation,
          employmentStatus: form?.employmentStatus,
        };
        formObj = JSON.parse(JSON.stringify({ ...staticForm, ...extraObj }));
      } else
        formObj = JSON.parse(JSON.stringify({ ...form, dateOfJoining: joiningDate }));

      // let response = await updateContractorPersonEmploymentStatus(id, {
      //   employee: formObj,
      // });

      let response = {};
      if (checkExisting) {
        response = await updateContractorPersonEmploymentStatus(
          id,
          {
            employee: formObj,
          },
          query
        );
      } else {
        response = await updateContractorPersonEmploymentStatus(id, {
          employee: formObj,
        });
      }

      if (response?.data?.existingData) {
        setConfirmMsg(response?.data?.existingData);
        setConfirmation(true);
        setLoading(false);
        return;
      } else {
        setConfirmation(false);
      }
      if (!response?.status) {
        setLoading(false);
        return toastr.error(response?.message);
      }

      setLoading(false);
      toastr.success(response.message || "Success.");
      // push(`/user-management/employee`);
      getFormData();
    },
    [form, getFormData, id, staticForm]
  );

  useEffect(() => {
    if (!id) return;

    getFormData();
  }, [getFormData, id]);
  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;
    setSiteList(response.data);
  }, []);
  useEffect(() => {
    getAllSiteList();
  }, [getAllSiteList]);
  const showTraining = useMemo(
    () => form.siteType === 3,
    // initialForm.siteType !== 3 &&
    // !form?.basicTrainingCompletionDate,
    [form.siteType]
  );
  const showMedical = useMemo(
    () =>
      form.siteType === 3 &&
      // initialForm.siteType !== 3 &&
      !form?.lastIMEDate,
    // !form?.lastPMEDate,
    [form?.lastIMEDate, form.siteType]
  );
  const onHideConfirmation = () => {
    setConfirmation(false);
  };
  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "Change location",
      message: "Are you sure you want to proceed with contractor staff status update",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => {
            onSubmit(e, false);
          },
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  }, [onSubmit]);
  return (
    <div>
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">Edit employment status</h3>
            <ContractorPersonActions id={id} form={staticForm} />
          </Card.Title>
          <WidgetBox form={staticForm} />
          <ViewBasicDetailsComponent form={staticForm} />
          {isActive ? (
            <>
              {!loading ? (
                <>
                  <div className="mt-2">
                    <h5>Employment Details</h5>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>{contractorPersonFormLabel["employmentStatus"]}</Label>
                          <SimpleSelect
                            name={"employmentStatus"}
                            value={form.employmentStatus}
                            options={contractorPersonEmploymentStatusList}
                            onChange={onChange}
                            label="name"
                            id="value"
                            placeHolder={contractorPersonFormLabel["employmentStatus"]}
                            error={error["employmentStatus"]}
                          />
                          <InputError error={error["employmentStatus"]} />
                        </FormGroup>
                      </Col>
                      {form.employmentStatus === "active" ? (
                        <Col md={4}>
                          <FormGroup>
                            <Label>{contractorPersonFormLabel["dateOfJoining"]}</Label>
                            <DatePicker
                              name={"dateOfReJoining"}
                              value={form.dateOfReJoining}
                              onChangeDate={onChange}
                              label={contractorPersonFormLabel["dateOfJoining"]}
                              placeHolder={contractorPersonFormLabel["dateOfJoining"]}
                              error={error["dateOfReJoining"]}
                              // disabled={!form.employmentStatus}
                              isValidDate={(e) =>
                                form?.retireResignDate
                                  ? e.isAfter(form?.retireResignDate)
                                  : true
                              }
                            />
                            <InputError error={error["dateOfReJoining"]} />
                          </FormGroup>
                        </Col>
                      ) : (
                        <></>
                      )}
                      {!(
                        !form.employmentStatus || form.employmentStatus === "active"
                      ) && (
                        <>
                          <Col md={6}>
                            <FormGroup>
                              <Label>
                                {contractorPersonFormLabel["dateOfSeparation"]}
                              </Label>

                              <DatePicker
                                name={"dateOfSeparation"}
                                value={form.dateOfSeparation}
                                onChangeDate={onChange}
                                label={contractorPersonFormLabel["dateOfSeparation"]}
                                placeHolder={
                                  contractorPersonFormLabel["dateOfSeparation"]
                                }
                                error={error["dateOfSeparation"]}
                                disabled={
                                  !form.employmentStatus ||
                                  form.employmentStatus === "active"
                                }
                                isValidDate={(e) => {
                                  return e.isSameOrAfter(staticForm?.startDateAtMines);
                                }}
                              />
                              <InputError error={error["dateOfSeparation"]} />
                            </FormGroup>
                          </Col>

                          <Col md={12}>
                            <FormTextArea
                              label={contractorPersonFormLabel["remark"]}
                              name={"remark"}
                              onChange={onChange}
                              value={form.remark}
                              // disabled={disabledForm}
                            />

                            <InputError error={error["remark"]} />
                          </Col>
                        </>
                      )}
                    </Row>
                    {form.employmentStatus === "active" ? (
                      <>
                        <InitialLocationForm
                          locationTitle={"New Location"}
                          contractorList={contractorList}
                          siteList={siteList}
                          form={form}
                          onChange={onChange}
                          error={error}
                          showContractor
                          showTraining={showTraining}
                          showMedical={showMedical}
                          lgClass={4}
                          isDisable={isDisable}
                        />
                        <Row>
                          {form?.lastPMEDate && form.siteType === 3 ? (
                            <Col md={4}>
                              <Label>
                                <h5>Last PME Date</h5> {DDMMYYYYFormat(form?.lastPMEDate)}
                              </Label>
                            </Col>
                          ) : (
                            ""
                          )}
                          {form?.lastIMEDate && form.siteType === 3 ? (
                            <Col md={4}>
                              <Label>
                                <h5>Last IME Date</h5> {DDMMYYYYFormat(form?.lastIMEDate)}
                              </Label>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <FormBtn
                    id={id}
                    onSubmit={onSubmit}
                    backOnClick={() => setIsActive(false)}
                    backBtnTitle={"Cancel"}
                  />
                </>
              ) : (
                <NetZeroLoader addZIndex={true} />
              )}
            </>
          ) : (
            ""
          )}

          {!isActive ? (
            <div className={"mt-4 text-center"}>
              <Button onClick={goBack} variant="secondary" className="mr-2">
                {"Back"}
              </Button>

              <Button
                onClick={() => setIsActive(true)}
                variant="primary"
                className="ml-2"
              >
                {"Change Status"}
              </Button>
            </div>
          ) : (
            ""
          )}
          <StatusHistoryList data={form?.dojHistoriesModified || []} />
        </Card.Body>
      </Card>
      {!loading ? (
        <ConfirmationModal
          confirmation={confirmation}
          onHideConfirmation={onHideConfirmation}
          confirmMsg={confirmMsg}
          confirmationAlert={confirmationAlert}
          title={"Contractor Status Update"}
          type={"status"}
          modalFor={"contractor staff"}
          checkMedicalForPending={false}
        ></ConfirmationModal>
      ) : (
        ""
      )}
    </div>
  );
}

export default ContractorPersonEmploymentForm;
